import React from "react";
import { Drawer } from "antd";
import { mediaQueryPoint, useMediaQuery } from "../../../../../utils/hooks";
import "./index.scss";
import BasePopup from "../Popup/index";
import bgHeaderTop from "../../../../../assets/images/Mini-Game/bg-header-popup-rule.png";
import iconClosePopup from "../../../../../assets/images/Event-2026/x-close.png";

export default function PopupFooter({
  children,
  isOpen,
  onClose,
  className,
  isShowSrcImgHeader = true,
  srcImgHeader = "",
  isGetContainer = true,
}) {
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);

  return (
    <>
      
        <BasePopup
          visible={isOpen}
          className={className}
          onCancel={onClose}
          getContainer
        >
          <div className="popup-minigame__2025">
            <div className="container-mini-popup">
              <span className="rule-mini-close" onClick={onClose}>
                <img src={iconClosePopup} alt="" />
              </span>

              {children}
            </div>
          </div>
        </BasePopup>
    </>
  );
}
